import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireCharacter?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requireCharacter = true }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }

  // Check if user needs to create a character
  // Don't redirect if we're already on the create-character page
  if (requireCharacter && !user.has_character && location.pathname !== '/create-character') {
    return <Navigate to="/create-character" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
